import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CustomerForm extends ThemeComponent {
    @Ref({ required: false }) recoverToggle!: HTMLButtonElement[];
    @Ref({ required: false }) recover!: HTMLElement;
    @Ref form!: HTMLElement;
    @Ref({required: false}) pwBox!: HTMLInputElement;
    @Ref({required: false}) showPasswordBtn!: HTMLElement;
    @Ref({required: false}) formFields!: HTMLInputElement[];
    @Ref({required: false}) submitBtn!: HTMLElement;
    protected url = location.href;

    /**
     * Initialise.
     */
    init() {
        this.showForm();
        this.setEventListeners();
    }

    /**
     * Set Event listeners.
     */
    setEventListeners() {
        for (const button of this.recoverToggle) {
            button.addEventListener("click", () => this.handlePasswordRecover(button));
        }

        const theme = document.body.getAttribute('data-theme') as string;
        if (theme === 'nova') {
            this.$listen(this.showPasswordBtn, 'click', this.onShowPasswordClicked.bind(this));
            for (const field of this.formFields) {
                this.$listen(field, 'input', this.validateFilled.bind(this));
            }

            if (this.pwBox) {
                this.$listen(this.pwBox, 'input', this.validateFilled.bind(this));
            }

            this.validateFilled();
        }
    }

    /**
     * Toggle Recover password form.
     */
    handlePasswordRecover(button: HTMLButtonElement|null) {
        this.recover.classList.toggle('is-active');
        this.form.classList.toggle('hidden');

        if (button === null) { return; }
        const toggle = button?.dataset.toggle;
        this.updateLocationUrl(toggle);
    }

    /**
     * Show / hide forms based of consitions.+
     * @returns
     */
    showForm() {
        if (!this.classList.contains('account-form--customer_login')) {
            this.form.classList.remove('hidden');
            return;
        }

        if (this.recover.querySelector('.errors') === null && location.href.indexOf('#recover') <= -1) {
            this.recover.classList.remove('is-active');
            this.form.classList.remove('hidden');
            return;
        }


        this.recover.classList.add('is-active');
        this.form.classList.add('hidden');
    }

    /**
     * Update location url.
     */
    updateLocationUrl(toggle: string|undefined) {
        if (toggle == 'show') {
            window.location.hash = 'recover';
            return;
        }

        history.replaceState(null, 'null', ' ');
    }

    // Nova theme features
    onShowPasswordClicked() {
        this.$log.info("show password clicked");
        if (this.pwBox.type === 'text') {
            this.pwBox.type = 'password';
        } else {
            this.pwBox.type = 'text';
        }
    }

    validateFilled() {
        let isValid = true;
        for (const field of this.formFields) {
            if (!field.value?.length) {
                isValid = false;
            }
        }
        if (this.pwBox && !this.pwBox.value.length) {
            isValid = false;
        }

        if (isValid) {
            this.$log.info("IS VALID");
            this.submitBtn.classList.remove('button--disabled');
        } else {
            this.$log.info("IS NOT VALID");
            this.submitBtn.classList.add('button--disabled');
        }
    }
}
